module.exports = __webpack_public_path__ + "img/资源 180.3521211b.png";